import axios from "axios";
import queryString from "query-string";
import { getApiBaseUrl } from "./runtimeBaseUrl";

// Use environment variable or default to relative URL (for production)
// In development, set REACT_APP_API_URL=http://localhost:3001
export const API_URL = getApiBaseUrl();

// Set up default config for http requests here
// Please have a look at here `https://github.com/axios/axios#request- config` for the full list of configs
const axiosClient = axios.create({
  baseURL: API_URL,
  headers: {
    "content-type": "application/json",
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }

    return response;
  },
  (error) => {
    // Handle errors
    throw error;
  }
);

export default axiosClient;
